module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="tos_input additional_tos_input ' +
((__t = ( isRequired ? 'required':'not_required' )) == null ? '' : __t) +
'">\n	';
 if (link) { ;
__p += '\n		<div class="tos_input_link_wrapper">\n			<!-- Not using <label> here since we don\'t want to highlight the checkbox when hovering the link-->\n			<input id="' +
((__t = ( id )) == null ? '' : __t) +
'" type="checkbox" aria-label="' +
((__t = ( labelv2 )) == null ? '' : __t) +
'" />\n			<a href="' +
((__t = ( link )) == null ? '' : __t) +
'" target="_blank">' +
((__t = ( labelv2 )) == null ? '' : __t) +
'</a>\n		</div>\n	';
 } else { ;
__p += '\n		<input id="' +
((__t = ( id )) == null ? '' : __t) +
'" type="checkbox">\n		<label for="' +
((__t = ( id )) == null ? '' : __t) +
'">' +
((__t = ( labelv2 )) == null ? '' : __t) +
'</label>\n	';
 } ;
__p += '\n\n	<div class="error">' +
((__t = ( I18n.t('uploader.form.validate.required') )) == null ? '' : __t) +
'</div>\n</div>\n';

}
return __p
}